var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"next btn-label",attrs:{"disabled":_vm.isDisabled,"color":"primary","block":""},on:{"click":function($event){return _vm.$emit('click', arguments)}}},[_c('v-icon',[_vm._v("$sl-arrow-right")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }